<section
  class="blueprint-scan"
  aria-hidden="true"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-speed-input]="speed"
  [style.--scene-intensity-input]="intensity"
>
  <div class="grid"></div>
  <span
    *ngFor="let mark of marks"
    class="mark"
    [style.left.%]="mark.left"
    [style.top.%]="mark.top"
    [style.--top]="mark.top"
    >{{ mark.label }}</span
  >
  <div class="scan"></div>
</section>
